import React, { useState,useRef } from "react";
import { useTranslate } from 'react-redux-multilingual';
import { InpDataList,CardPerso,SubmitForm} from "@gull";
import { useForm } from "react-hook-form";
import axios from 'axios';
import swal from "sweetalert2";
import { useHistory } from "react-router-dom";

const EachDataFilter = (props) => {
   
    const inputRef = useRef('')
    const listRef = useRef('')
    const [datas,setDatas] = useState(props.fournisseurs)
        
    const handleClickFilter = (id,label,nameInput) => {
        props.setValueInput(label)
        props.setFournisseurId(id)
    }

    const handleSearch = (e,declenchement) => {
        props.setValueInput(e.target.value);
        let ajour = props.fournisseurs.filter((value)=>value.name.toLowerCase().includes(e.target.value.toLowerCase()))
        setDatas(ajour)
    }

    const handleFocus = () => {
        setDatas(props.fournisseurs)
        listRef.current.classList.remove("d-none");
    }

    const handleBlur = () => {
        listRef.current.classList.add("d-none")
    }

    return(
        <InpDataList
            placeholder="-- Select --"
            value={props.valueInput}
            onClick={handleClickFilter}
            onChange={handleSearch}
            datas={datas}
            declenchement={0}
            listRef={listRef}
            inputRef={inputRef}
            onFocus={handleFocus}
            onBlur={handleBlur}
            inputName={props.inputName}
        />
    )
}

const PurchaseOrderCreate = (props) => {
    const t = useTranslate();
    const { register, formState: { errors }, handleSubmit, setValue, reset} = useForm();
    const [validButton,setValidButton] = useState(false)
    const [apiError,setApiError] = useState(false)
    const [success,setSuccess] = useState(false)
    const [fournisseurId,setFournisseurId]=useState('')
    const [valueInput,setValueInput] = useState('')
    const history = useHistory();

    const onSubmit = async (data) => {
        setValidButton(true)
        setApiError(false)
        setSuccess(false)
        data['fournisseur']=`${fournisseurId}` //on converti la valeur de fournisseurId en sting
        if(props.from=='pos' && props.posid) data['section']=props.posid;
        const response  = await axios.post(process.env.REACT_APP_API_URL+"api/erp/po",data
        ).then((response) => {
            if(!response.data.valid){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach((interm)=>{
                    let finalMessage=interm.split('/!');
                    if(finalMessage.length==2){
                        messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                    }
                    else{
                        messageError+=t(interm)+'<br/>'
                    }
                })
                    messageError=messageError.replace('undefined','');
                    setApiError(messageError)
            }
            else{
                if(props.from=='erp') history.push("/erp/purchase-order/details/"+response.data.po.id)
                else if(props.posid) history.push("/pos/"+props.posid+"/purchase-order-detail/"+response.data.po.id)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let errorName = (error.response==undefined) ? 'unknowError' : (error.response.status==403) ? 'forbiddenGeneral' : 'unknowError'
            swal.fire(t(errorName), "", "error");
        })
        setValidButton(false)
        setTimeout(()=>{
            setSuccess(false);
        },1000)
        
    }

    return (
        <div className="row d-flex justify-content-center">
            <div className="col-6">
                <CardPerso header={t('createPurchaseOrder')}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="form-group">
                            <label htmlFor="nomcategorie">{t('purchaseOrderName')+' :'}</label>
                            <input id="name" className="form-control" type="text" {...register('name', {required: true,minLength:2,maxLength:250})}/>
                            {errors.name?.type === 'required' && (
                            <div className="text-danger mt-1 ml-2">
                                {t('nameRequired')}
                            </div>
                            )}
                            {errors.name?.type === 'minLength' && (
                            <div className="text-danger mt-1 ml-2">
                                {t('nameMin2')}
                            </div>
                            )}
                            {errors.name?.type === 'maxLength' && (
                            <div className="text-danger mt-1 ml-2">
                                {t('nameMax250')}
                            </div>
                            )}
                        </div>
                        <div className="form-group">
                            <label htmlFor="memo">Memo :</label>
                            <textarea rows={5} className="form-control" {...register('memo')}/>
                        </div>
                        <div className="form-group">
                            <label htmlFor="devise_achat">{t('devise_achat')+' :'}</label>
                            <input id="devise_achat" className="form-control" type="text" {...register('devise_achat', {required: true,minLength:3,maxLength:3})}/>
                            {errors.devise_achat?.type === 'required' && (
                            <div className="text-danger mt-1 ml-2">
                                {t('deviseAchatRequired')}
                            </div>
                            )}
                            {errors.devise_achat?.type === 'minLength' && (
                            <div className="text-danger mt-1 ml-2">
                                {t('deviseAchatMin')}
                            </div>
                            )}
                            {errors.devise_achat?.type === 'maxLength' && (
                            <div className="text-danger mt-1 ml-2">
                                {t('deviseAchatMax')}
                            </div>
                            )}
                        </div>
                        <div className="form-group">
                            <label htmlFor="nomcategorie">{t('fournisseur')+' :'}</label>
                            <EachDataFilter 
                                fournisseurs={props.fournisseurs} 
                                setFournisseurId={setFournisseurId}
                                valueInput={valueInput}
                                setValueInput={setValueInput}
                            /> 
                        </div>
                        <div className="form-group">
                            <label htmlFor="section">{t('assignAShop')+' :'}</label>
                            <select className="form-control"  {...register('section')}>
                                <option value="">-- Select --</option>
                                {props.authParam.sections.map((value,index)=>{
                                    if(value.type!='ecommerce') return(<option key={index} value={value.id}>{value.name}</option>)
                                })}
                            </select>
                        </div>
                        {props.customFieldsCol.map((item,index)=>(
                            <div className="form-group" key={index}>
                                <label htmlFor={item.name}>{item.name}{(item.required) ? '*' : false}</label>
                                {(item.free) ?
                                    <>
                                        <input className="form-control" type="text" {...register(item.name,{required:item.required})}/>
                                        {errors[item.name]?.type === 'required' && (
                                        <div className="text-danger mt-1 ml-2">
                                            {t('youMustIndicateField')+' "'+item.name+'"'}
                                        </div>
                                        )}
                                    </>
                                    :
                                    <>
                                        <select className="form-control" {...register(item.name,{required:item.required})} >
                                            <option value="">-- Select --</option>
                                            {item.list.map((value,index)=>
                                                <option key={index} value={value}>{value}</option>
                                            )}
                                        </select>
                                        {errors[item.name]?.type === 'required' && (
                                        <div className="text-danger mt-1 ml-2">
                                            {t('youMustIndicateField')+' "'+item.name+'"'}
                                        </div>
                                        )}
                                    </>
                                }
                            </div>
                        ))}
                        <SubmitForm error={apiError} success={success} validButton={validButton}/>
                    </form>
                </CardPerso>
            </div>
        </div>
        
    );
}

export default PurchaseOrderCreate;